fragment EnrollmentFormFragment on EnrollmentForm {
    status
    values {
        name
        value
        error
    }
    canSubmit
    twilioRejectionReasons
}
